export default __webpack_public_path__ + "static/media/exterior9.c85c7ebd.jpg";